import script from "./Table.vue?vue&type=script&lang=ts&setup=true"
export * from "./Table.vue?vue&type=script&lang=ts&setup=true"

import "./Table.vue?vue&type=style&index=0&id=62407510&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62407510"]])

export default __exports__